<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <span
          v-if="devices.length != 0"
          class="rounded border border-success w-100 d-block font-weight-normal p-2"
          ><i class="fas fa-camera-retro ml-2"></i> وبــکم شما روشن است ، برای
          گرفتن عکس بر روی دکمه
          <span class="badge badge-danger font-weight-normal">گرفتن عکس</span>
          کلیک کنید</span
        >
        <span
          v-else
          class="rounded border border-danger p-2 w-100 d-block font-weight-normal"
        >
          وبکم شناسایی نشد</span
        >
      </div>
    </div>
    <div class="row" v-if="devices.length != 0">
      <div class="col-md-6">
        <h2>دوربین فعال</h2>
        <code v-if="device">{{ device.label }}</code>
        <div :class="sep()" id="shutter" style="overflow: hidden">
          <vue-web-cam
            ref="webcam"
            :device-id="deviceId"
            width="100%"
            height="100%"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          />
        </div>
      </div>
      <div class="col-md-6">
        <!-- <h2>گرفتن فیلم </h2> -->
        <figure class="figure">
          <img
            :src="img"
            class="img-responsive"
            style="width: 100%; height: 50%"
          />
        </figure>
      </div>
    </div>
    <div class="row" v-if="devices.length != 0">
      <div class="col-md-6 row rounded border mr-3 mb-2 bg-light">
        <div class="col-4 pt-4 mr-1">
          <small style="display: inline-block">انتخاب دوربین</small>
        </div>
        <div class="col-7 pb-3">
          <select
            v-model="camera"
            :disabled="devices.length == 0"
            class="mt-3 mb-2w-50 form-control Pointer"
            style="display: inline-block"
          >
            <option class="d-none" selected disabled value="-1">
              -- انتخاب دوربین --
            </option>
            <option
              v-for="device in devices"
              :key="device.deviceId"
              :value="device.deviceId"
            >
              {{ device.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <div class="col-md-12 row mr-2">
        <!-- <div class="col-3 p-2">
                    <button type="button" v-if="devices.length !=0" class="btn w-100 btn-dark " @click="onStart">شروع</button>
                </div> -->
        <div class="col-3 p-2" v-if="devices.length != 0">
          <button type="button" class="btn w-100 btn-dark" @click="onCapture">
            <i class="fas fa-camera"></i> گرفتن عکس
          </button>
        </div>
        <div class="col-3 p-2" v-if="devices.length != 0">
          <button type="button" class="btn w-100 btn-dark" @click="onStop">
            <i class="fas fa-times"></i> توقف دوربین
          </button>
        </div>
        <div class="col-3 p-2" v-if="devices.length != 0">
          <button type="button" class="btn w-100 btn-dark" @click="onStart">
            <i class="fas fa-save"></i> دخیره عکس
          </button>
        </div>
        <div class="col-3 p-2" v-if="devices.length != 0">
          <button
            type="button"
            class="btn w-100 btn-dark-danger"
            data-dismiss="modal"
          >
            <i class="fas fa-times"></i> بستن
          </button>
        </div>
        <div class="col-4 p-2" v-if="devices.length == 0">
          <button
            type="button"
            class="btn w-100 btn-dark-danger"
            data-dismiss="modal"
          >
            <i class="fas fa-times"></i> بستن
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WebCam } from "vue-web-cam";

export default {
  name: "App",
  components: {
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      shitterEfect: "bg-light border h-50",
    };
  },
  computed: {
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;

      console.log(tail);
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
  methods: {
    sep() {
      return this.shitterEfect;
    },
    shutterc() {
      this.shitterEfect = "bg-light border set";
      this.$nextTick(() => {
        setTimeout(() => {
          this.shitterEfect = "bg-light border h-50";
        }, 500);
      });
    },
    onCapture() {
      this.shutterc();
      this.img = this.$refs.webcam.capture();
      // console.log(this.iduploader, document.getElementById(this.iduploader));
    },
    saveImage() {
      if (this.img != null) {
        document.getElementById(this.idshowimg).setAttribute("src", this.img);
        document.getElementById(this.iduploader).value = this.img;
      } else {
        this.$mySweetDefaultTost(
          "هشدار",
          "تصویری برای ذخیره انتخاب نشده اسعت",
          "error",
          2000
        );
      }
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      // console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      // console.log("On Camera Change Event", deviceId);
    },
  },
  created() {},
  mounted() {},
  props: ["idshowimg", "iduploader"],
};
</script>
<style scoped>
#shutter {
  transition: 1s;
  height: 50%;
  overflow: hidden;
}

.set {
  transition: 0.5s;
  height: 0;
  /* width: 0; */
  opacity: 0.7;
  border-radius: 100%;

  background: #000 !important;
}
shutter.h-50 {
  transition: 0.5s;
  height: 50%;
}
</style>
